<div class="container px-4">
  <div class="change-plan-page">
    <!-- Header Section -->
    <header class="page-header">
      <a href="#" class="back-link"
        ><i class="ri-arrow-left-line"></i> Change Your Plan</a
      >
      <p>
        <strong>You have the option to change your plan.</strong> <br />
        This allows you to upgrade or downgrade your existing plan based on your
        needs and preferences. <br />
        Plan prices don’t include applicable taxes.
      </p>
    </header>

    <!-- Plans Section -->
    <div class="plans-grid">
      <div class="plan-card" *ngFor="let plan of plans">
        <div class="plan-header">
          <h2>{{ plan.name }}</h2>
        </div>
        <div class="plan-details">
          <div class="detail">
            <p class="pl-2">Download speed</p>
            <div class="flex justify-center items-center pt-3 space-x-2">
              <div class="icon">
                <img src="/icons/download.svg" alt="download" />
              </div>
              <p class="plan-txt">
                <strong>{{ plan.downloadSpeed }} </strong>
                Mbps
              </p>
            </div>
          </div>
          <div class="detail">
            <p class="pl-2">Upload speed</p>
            <div class="flex justify-center items-center pt-3 space-x-2">
              <div class="icon">
                <img src="/icons/upload.svg" alt="upload" />
              </div>
              <p class="plan-txt">
                <strong>{{ plan.uploadSpeed }} </strong>
                Mbps
              </p>
            </div>
          </div>
        </div>
        <div class="plan-info flex items-center gap-3">
          <img src="/icons/info.svg" alt="info" />
          <p>{{ plan.description }}</p>
        </div>
        <div class="flex justify-between items-center price-box my-5">
          <div class="price-txt">
            <p>
              <strong>${{ plan.price }}</strong>
              /month
            </p>
          </div>
          <div class="plan-actions flex items-center justify-end space-x-2">
            <label [for]="plan.uploadSpeed">Select</label>
            <div class="custom-radio">
              <input type="radio" id="{{ plan.uploadSpeed }}" name="payment" />
              <label for="{{ plan.uploadSpeed }}"></label>
            </div>
            <button class="save-button" *ngIf="selectedPlan === plan.id">
              Save
            </button>
          </div>
        </div>
        <div class="save-button">
          <button type="button">Save</button>
        </div>
      </div>
    </div>
  </div>

</div>
